// PatternKit.jsx – zentrale Sammlung aller Sketch-Komponenten
import MonoButton from "./MonoButton";
import UnderlineSketch from "./UnderlineSketch";
import { Headline, Subline, BodyText } from "./TypeSystem";
import CodeEditor from "./CodeEditor";
import CodeEditorTabs from "./CodeEditorTabs";

import PaperBG from "./PaperBG";
import SketchFigure from "./SketchFigures"; // ← wenn deine Datei so heißt
import LessonTabs from "../../courses/LessonTabs"; // ← oder "./LessonTabs" wenn du es reingezogen hast

// Universell verwendbare Sketch-Komponenten
const SketchCard = ({ children }) => (
  <div className="border border-black rounded-lg px-4 py-3 font-mono text-sm text-black bg-white">
    {children}
  </div>
);

const SectionFrame = ({ children }) => (
  <div className=" p-6 md:p-10 max-w-6xl mx-auto">
    {children}
  </div>
);

// Haupt-Komponente für visuelle Vorschau – kann produktiv genutzt oder ignoriert werden
const PatternKit = () => {
  return (
    <PaperBG className="min-h-screen bg-white text-black font-mono p-8 space-y-12">
      <header className="text-center space-y-2">
        <h1 className="text-3xl tracking-tight">Pattern-Kit</h1>
        <p className="text-sm text-gray-600">Ein Sketchbook aus Code. Klar. Ausdrucksstark. Leise.</p>
      </header>

      <section className="space-y-4">
        <h2 className="text-xl">01 – UnderlineSketch</h2>
        <div className="relative w-48 h-6">
          <UnderlineSketch color="#ec4899" className="absolute bottom-0 w-full h-2" />
          <span className="relative z-10">Magst du lernen?</span>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl">02 – MonoButton</h2>
        <div className="w-fit">
          <MonoButton onClick={() => alert("Clicked")}>Jetzt starten</MonoButton>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl">03 – Kurskarten Grid</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          <SketchCard>Kurs A</SketchCard>
          <SketchCard>Kurs B</SketchCard>
          <SketchCard>Kurs C</SketchCard>
        </div>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl">04 – Typografie</h2>
        <SectionFrame>
          <Headline>Lehre mit Haltung</Headline>
          <Subline>Worte, die wirken</Subline>
          <BodyText>
            Dies ist ein Beispieltext. Er folgt einer klaren Linie, verwendet feste Abstände und wirkt dennoch leicht.
          </BodyText>
        </SectionFrame>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl">05 – Codeblock mit Tabs</h2>
        <CodeEditor filename="greet.js" language="js">
          {`function greet(name) {
  return "Hallo, " + name + "!";
}`}
        </CodeEditor>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl">06 – Code Editor mit Tabs</h2>
        <CodeEditorTabs
          files={[
            {
              filename: "index.js",
              language: "js",
              code: `function greet(name) {\n  return "Hallo, " + name + "!";\n}`,
            },
            {
              filename: "style.css",
              language: "css",
              code: `body {\n  font-family: sans-serif;\n  background: #f8fafc;\n}`,
            },
            {
              filename: "README.md",
              language: "md",
              code: `# Projektbeschreibung\nDies ist ein einfaches PatternKit zur Darstellung von Komponenten.`,
            },
          ]}
        />
      </section>

      <section className="space-y-4">
        <h2 className="text-xl">07 – Lesson Tabs</h2>
        <LessonTabs />
      </section>

      <section className="space-y-4">
        <h2 className="text-xl">08 – Sketch Figure</h2>
        <SketchFigure />
      </section>
    </PaperBG>
  );
};

export default PatternKit;
export { SectionFrame, SketchCard, MonoButton, UnderlineSketch, PaperBG };